"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionBoundaryDefinitionSchema = exports.IComponentFunctionBoundaryDefinitionSchema_ConnectionDefinition = exports.IComponentFunctionBoundaryDefinitionSchema_NumericalDefinition = void 0;
const zod_1 = require("zod");
const INumericalBoundaryDefinition_1 = require("../DesignModels/INumericalBoundaryDefinition");
const IConnectionBoundaryDefinition_1 = require("../DesignModels/IConnectionBoundaryDefinition");
const IBoundaryBase_1 = require("../DesignModels/IBoundaryBase");
exports.IComponentFunctionBoundaryDefinitionSchema_NumericalDefinition = INumericalBoundaryDefinition_1.INumericalBoundaryDefinitionSchema.merge(IBoundaryBase_1.IBoundaryBaseSchema.omit({ target: true, relative_to: true })).extend({
    target: zod_1.z.union([
        IBoundaryBase_1.IBoundaryBaseSchema.shape.target,
        zod_1.z.object({
            signalSlots: zod_1.z.string().array(),
        }),
    ]),
    relative_to: zod_1.z
        .union([
        IBoundaryBase_1.IBoundaryBaseSchema.shape.relative_to,
        zod_1.z.object({
            signalSlots: zod_1.z.string().array(),
        }),
    ])
        .optional(),
});
exports.IComponentFunctionBoundaryDefinitionSchema_ConnectionDefinition = IConnectionBoundaryDefinition_1.IConnectionBoundaryDefinitionSchema.merge(IBoundaryBase_1.IBoundaryBaseSchema.omit({ target: true, relative_to: true })).extend({
    target: zod_1.z.union([
        IBoundaryBase_1.IBoundaryBaseSchema.shape.target,
        zod_1.z.object({
            signalSlots: zod_1.z.string().array(),
        }),
    ]),
    relative_to: zod_1.z
        .union([
        IBoundaryBase_1.IBoundaryBaseSchema.shape.relative_to,
        zod_1.z.object({
            signalSlots: zod_1.z.string().array(),
        }),
    ])
        .optional(),
});
exports.IComponentFunctionBoundaryDefinitionSchema = zod_1.z.discriminatedUnion('type', [
    exports.IComponentFunctionBoundaryDefinitionSchema_NumericalDefinition,
    exports.IComponentFunctionBoundaryDefinitionSchema_ConnectionDefinition,
]);
//# sourceMappingURL=IComponentFunctionBoundaryDefinition.js.map